import { keyframes } from "styled-components";

export const COLORS = {
  teal: "#4f8884",
  tealSoft: "#dceae5",
  gold: "#c6ab57",
  orange: "#A4400A",
  orangeShadow: "#d09b53",
  ink: "#203033",
  body: "#585858",
};

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(18px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
